export type PCustomerPrice = {
	articleID?: string;
	id?: string;
	validUntil?: string | null;
	validFrom: string | null;
	retailerID?: string;
	priceIncludingFreight: number | null;
	price?: number | null;
};

export const isPriceDateValid = (customerPrice: PCustomerPrice): boolean => {
	if (!customerPrice) return false; // Handle case where customerPrice is null/undefined
	const currentDate = new Date();
	// Check if `validUntil` is null or it's a future date
	const isValidUntil =
		!customerPrice.validUntil ||
		new Date(customerPrice.validUntil) > currentDate;

	// Check if `validFrom` is in the past or today
	const isValidFrom = customerPrice.validFrom
		? new Date(customerPrice.validFrom) <= currentDate
		: false;

	return isValidUntil && isValidFrom;
};

export const getCustomerPrice = (
	customerPrice?: PCustomerPrice,
): number | null => {
	if (!customerPrice || !isPriceDateValid(customerPrice)) return null;
	return customerPrice.price ?? customerPrice.priceIncludingFreight;
};
